<template>
    <div>
        <div class="banner-container">
            <img class="career-img" src="../../assets/image/career/career-banner.jpg" />
            <p class="join-title">Join Our Team</p>
        </div>
        <el-breadcrumb class="breadcrumb-container" separator="/">
            <el-breadcrumb-item class="breadcrumb-item" :to="{ path: '/career' }">Career</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb-item">Marketing Manager ( 营销经理 )</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="job-container">
            <p class="title">Marketing Manager ( 营销经理 )</p>
            <div class="description-container">
                <p class="subtitle"> 职位负责</p>
                <ul class="requirement-list">
                    <li class="list-details"> 负责全国性大中型集团客户、行业标杆客户的挖掘与营销拓展。</li>
                    <li class="list-details"> 负责拓展及维护核心、一级代理商，促进POS机具销售及落地工作。</li>
                    <li class="list-details"> 带领市场团队完成定期市场业绩目标。</li>
                    <li class="list-details"> 协助制定短期及中期的POS支付、扫码支付产品营销政策。</li>
                </ul>
                <p class="salary">SALARY: NEGOTIABLE</p>
                <p class="subtitle">岗位要求</p>
                <ul class="requirement-list">
                    <li class="list-details"> 本科以上学历，能使用中文、英文、高棉语进行工作和交流。</li>
                    <li class="list-details"> 有优质POS和扫码支付代理商及行业客户资源优先考虑。</li>
                    <li class="list-details"> 能够独立完成方案的编写及推广工作，有较强的谈判技能，抗压能力强。</li>
                    <li class="list-details"> 具备良好的沟通能力、做事认真、有耐心和责任心，具备良好的团队协作和服务意识。</li>
                    <li class="list-details"> 有第三方支付销售经验或者POS机具销售经验优先考虑。</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">How to Apply</p>
                <p class="requirement-list">Interested candidates please submit your CV/resume with a photo and accompanied by cover letter and any other supporting documents to HR Department:</p>
                <div class="hr-contact">
                    <p class="hr-contact-details">Contact Person : HR Department</p>
                    <p class="hr-contact-details">Email: hr@u-pay.com</p>
                    <p class="hr-contact-details">Contact: 069 931 888 / 077 266 123 </p>
                    <p class="hr-contact-details">Website: www.u-pay.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  .career-img {
    width: 100%;
  }
  .join-title {
    color: white;
    position: absolute;
    bottom: 3%;
    left: 4%;
    font-size: 2.2rem;
    font-weight: bolder;
  }
}
.job-container {
    display: table;
    margin-right: auto;
    margin-left: auto;
    padding: 3% 25% 3% 25%;
    .title {
        color: #0277E3;
        text-align: center;
        font-size: 1.55rem;
        font-weight: bold;
    }
}

.description-container{
    padding-top: 8%;
    .subtitle {
        color: black;
        text-align: center;
        font-size: 1.35rem;
        font-weight: bold;
    }
    .requirement-list{
        margin: 3% 0% 5% 0%;

        .list-details {
            margin-bottom: 0.7%;
            display: list-item;
            list-style-type: disc;
        }
    }
    .salary{
        font-weight: bolder;
    }

    .hr-contact .hr-contact-details {
        margin-bottom: 3%;
        font-weight: bold;
    }
}

.breadcrumb-container {
    margin : 3% 3%;
}

.breadcrumb-item {
    color: darkgray;
    font-weight: 600;
    font-size: 1.0rem;
}

@media only screen and (max-width: 600px) {
    .job-container {
        display: table;
        margin-right: auto;
        margin-left: auto;
        padding: 3% 5% 3% 5%;
        .title {
            color: #0277E3;
            text-align: center;
            font-size: 1.10rem;
            font-weight: bold;
        }
    }
}
</style>
